<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'NewsCenter',
            to: {
              name: 'NewsCenter'
            }
          },
          {
            name: 'Edit',
            to: {
              name: 'NewsEdit',
              params: {
                id: $route.params.id
              }
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>修改文章</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 新增文章 -->
    <NewsCreateEdit></NewsCreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import NewsCreateEdit from '@/views/E-4__News/c/NewsCreateEdit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    NewsCreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('news', ['news']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getNews(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('news', {
      getNews: 'findById',
      save: 'save',
    }),
    cancelHandler() {
      this.$router.push({ name: 'NewsCenter' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.errors = [];
        if (this.$refs.form.validate()) {
          if (!this.news.title) {
            this.errors.push('News Tilte required.');
          } else if (!this.news.tab) {
            this.errors.push('Tab required.');
          } else if (!this.news.published_at) {
            this.errors.push('發佈日 required.');
          }/* else if (!this.news.slug) {
            this.errors.push('Slug required.');
          } */
          if (this.errors.length > 0) {
            /* eslint-disable */
            alert(this.errors);
            /* eslint-disable */
            return false;
          }
          this.save(this.news).then(() => {
            this.$router.push({ name: 'NewsCenter' });
          });
        }
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
